<template>
    <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg" class="mr-1" style="vertical-align:text-bottom;">
    	<g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    	<g id="Template-1-/-Course-Info" transform="translate(-228 -263)">
    	<g id="TOP-INFO" transform="translate(48 203)"><g id="sub-info" transform="translate(0 58)">
    	<g id="location" transform="translate(178)"><g id="icon/misc/location">
    		<path d="M14.588 12.573c-1.46-1.458-2.475-2.853-3.034-4.188l-2.739.674v5.694l5.773-2.103v-.077zm1.15.113l5.307 1.73V9.054l-2.484-.641c-.516 1.373-1.46 2.797-2.824 4.273zM11.23 7.435A5.663 5.663 0 0111.039 6c0-2.708 1.922-4 4.05-4 2.126 0 3.936 1.244 3.936 4 0 .479-.058.964-.172 1.455l2.817.728a.5.5 0 01.375.484v12.874a.5.5 0 01-.649.478l-6.311-1.967-6.628 1.969a.5.5 0 01-.305-.007l-5.815-2.012A.5.5 0 012 19.529V7a.5.5 0 01.638-.48l5.177 1.484V8h1v.029l2.415-.594zM3 14.32v4.853l4.815 1.666v-4.99l-2.085-.566a.5.5 0 01.262-.965l1.823.495v-5.77L3 7.664v5.597l.028.01 1.5.53a.5.5 0 01-.333.942L3 14.32zm5.815 1.497v5.054l5.773-1.715v-1.68a.5.5 0 011 0v1.685l5.457 1.7v-5.393l-5.457-1.78v1.935a.5.5 0 01-1 0v-1.909l-5.773 2.103zM18.025 6c0-2.107-1.3-3-2.937-3-1.64 0-3.05.948-3.05 3 0 1.702 1.046 3.634 3.172 5.78C17.096 9.678 18.025 7.75 18.025 6zM15 8a2 2 0 110-4 2 2 0 010 4zm0-1a1 1 0 100-2 1 1 0 000 2z" id="Combined-Shape" fill="#256AB3" fill-rule="evenodd"/>
    	</g></g></g></g></g></g>
    </svg>
</template>

<script>
export default {
    name: "LocationIcon",
    props: {
        color: {
            type:String,
            default() {
                return '#256AB3F';
            }
        }
    }
}
</script>

<style scoped>

</style>
